import React from "react";
import ProgressiveImage from "react-progressive-graceful-image";

const LazyBlur = ({
  src,
  placeholder = "",
  className = "",
  style = {},
  alt,
}) => {
  return (
    <>
      <ProgressiveImage src={src} placeholder={placeholder}>
        {(loadedSrc, loading) => (
          <img
            src={loadedSrc}
            alt={alt}
            loading="lazy"
            srl_gallery_image="true"
            className={className}
            style={{
              opacity: loading ? 0.5 : 1,
              transition: "opacity 1s cubic-bezier(0.075, 0.82, 0.165, 1)",
              ...style,
            }}
          />
        )}
      </ProgressiveImage>
    </>
  );
};

export default LazyBlur;
